module.exports = __webpack_public_path__ + "static/media/ArbFONTS-Janna-LT-Regular (1).378ee291.ttf";